import ExportImg from '@assets/images/video-tutorial/export.png'
import { VideoTutorial } from '@components/VideoTutorial'
import { useVideoTutorial } from '@components/VideoTutorial/useVideoTutorial'
import type React from 'react'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { VideoTutorialWrap } from '../VideoTutorialWrap'

interface Props {
  hide: boolean
}

export const ExportTutorial: React.FC<Props> = ({ hide }) => {
  const { exportId, handleViewedTutorial } = useVideoTutorial()

  if (!exportId) {
    return null
  }

  const handleLinkClick = () => {
    handleViewedTutorial(exportId)
    sendGtmEvent(GtmTriggerName.EXPORT_INTRO)
  }

  const handleCloseClick = () => {
    handleViewedTutorial(exportId)
  }

  return (
    <VideoTutorialWrap hide={hide} isExport>
      <VideoTutorial
        title="Welcome to Export"
        description="Easily share sitemap with clients and teammates."
        img={ExportImg}
        link="https://youtu.be/tb9eNFN3A8E?si=d6BgH9NAu1K51D6u"
        position="left-top"
        onLinkClick={handleLinkClick}
        onCloseClick={handleCloseClick}
      />
    </VideoTutorialWrap>
  )
}
